import { State } from '@/store/user/types';

export const state = (): State => ({
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
    betaDisclaimer: true,
});